<template>
  <Popover :open="open" @update:open="onUpdate">
    <PopoverAnchor as-child>
      <button
        type="button"
        class="inline-flex size-6 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        :aria-label="`En savoir plus : ${label}`"
        :aria-expanded="open"
        @click="toggle"
        @mouseenter="show"
        @mouseleave="hideSoon"
      >
        <Info class="size-4" aria-hidden="true" />
      </button>
    </PopoverAnchor>
    <PopoverContent
      side="top"
      align="start"
      class="w-72 text-sm leading-relaxed"
      @open-auto-focus.prevent
      @mouseenter="show"
      @mouseleave="hideSoon"
    >
      {{ text }}
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts">
import { Info } from 'lucide-vue-next'
import { ref } from 'vue'

import { Popover, PopoverAnchor, PopoverContent } from '@/components/ui/popover'

// Explanation of a figure. Hover shows it; a click or a tap (touch screens have no hover) pins it open
// until the next click, Escape or a click elsewhere.
defineProps<{ label: string; text: string }>()

const open = ref(false)
const pinned = ref(false)
let timer: ReturnType<typeof setTimeout> | undefined

function show() {
  clearTimeout(timer)
  open.value = true
}
function hideSoon() {
  if (pinned.value) return
  clearTimeout(timer)
  timer = setTimeout(() => (open.value = false), 150)
}
function toggle() {
  pinned.value = !pinned.value
  open.value = pinned.value
}
function onUpdate(value: boolean) {
  if (!value) pinned.value = false
  open.value = value
}
</script>
